// src/index.js
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { FileProvider } from './ContextAPI/FileContext'; // Import the FileProvider
import { DownloadsProvider } from './contexts/DownloadsContext';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

ReactDOM.render(
  <FileProvider>
    <DownloadsProvider>
      <App />
    </DownloadsProvider>
  </FileProvider>,
  document.getElementById('root')
);
